export default __webpack_public_path__ + "static/media/no-image.cc8c4661.jpg";